'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ = require('.');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeadingBlock = function HeadingBlock(_ref) {
  var title = _ref.title,
      className = _ref.className,
      icon = _ref.icon,
      children = _ref.children;

  return _react2.default.createElement(
    'section',
    { className: 'HeadingBlock ' + (className || '') },
    _react2.default.createElement(
      'h1',
      null,
      icon && _react2.default.createElement(_.Icon, { name: icon }),
      title
    ),
    children
  );
};

HeadingBlock.propTypes = {
  /**
   * The title of the block.
   */
  title: _propTypes2.default.string.isRequired,
  /**
   * The CSS class of the block.
   */
  className: _propTypes2.default.string,
  /**
   * File name of the icon.
   */
  icon: _propTypes2.default.string,
  /**
   * The content of the block.
   */
  children: _propTypes2.default.any
};

exports.default = HeadingBlock;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/HeadingBlock.js
// module id = 271
// module chunks = 0